import { render, staticRenderFns } from "./VenuePerformance.vue?vue&type=template&id=73bf8ce1&"
import script from "./VenuePerformance.vue?vue&type=script&lang=js&"
export * from "./VenuePerformance.vue?vue&type=script&lang=js&"
import style0 from "./VenuePerformance.vue?vue&type=style&index=0&id=73bf8ce1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports